import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteLimiteCredito } from '../cliente-limite-credito';

@Injectable({
    providedIn: 'root'
})
export class ClienteLimiteCreditoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cliente/0/limitecredito`
    }

    /** Obtem os limítes de crédito dos clientes */
    getLimiteCredito(idsClientes: number[]): Observable<ClienteLimiteCredito> {
        // Params
        let params = new HttpParams();
        // Clientes
        if (idsClientes) {
            idsClientes.forEach(idCliente => {
                params = params.append('idCliente', idCliente.toString());
            });
        }

        return this.customHttp.get<ClienteLimiteCredito>(this.pathApi, {params});
    }

    /** Obtem os limítes de crédito dos clientes através de suas pessoas */
    getLimiteCreditoByPessoa(idsPessoas: number[]): Observable<ClienteLimiteCredito> {
        // Params
        let params = new HttpParams();
        // Pessoa
        if (idsPessoas) {
            idsPessoas.forEach(idPessoa => {
                params = params.append('idPessoa', idPessoa.toString());
            });
        }

        return this.customHttp.get<ClienteLimiteCredito>(`${this.pathApi}/pessoa`, {params});
    }
}
